import Headroom from 'headroom.js';
import ToggleButton from './header-toggle';

// Navigation toggle button
document.querySelectorAll('.header__button-navigation-toggle').forEach($toggleButton => new ToggleButton($toggleButton));

// Headroom Js
const myElement = document.querySelector('header');
const headroom = new Headroom(myElement, {
  classes: {
    initial: 'animated',
    pinned: 'fadein',
    unpinned: 'fadeout',
  },
});

document.querySelectorAll('.navigation').forEach(() => {
  headroom.init();
});
